import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var DesignTokenDefinition = /*#__PURE__*/_createClass(function DesignTokenDefinition(type) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  _classCallCheck(this, DesignTokenDefinition);
  this.type = type;
  this.args = args;
  this.options = options;
});
export function tokenDefinition(type, args, options) {
  return new DesignTokenDefinition(type, args, options);
}
export function optionalTokenDefinition(type, args, options) {
  return new DesignTokenDefinition(type, args, _objectSpread(_objectSpread({}, options), {}, {
    optional: true
  }));
}
export function colorToken(args, options) {
  return new DesignTokenDefinition('Color', args, options);
}
export function optionalColorToken(args, options) {
  return new DesignTokenDefinition('Color', args, _objectSpread(_objectSpread({}, options), {}, {
    optional: true
  }));
}
export function sizeToken(args, options) {
  return new DesignTokenDefinition('Size', args, options);
}
export function textStyleToken(args, options) {
  return new DesignTokenDefinition('TextStyle', args, options);
}
export function boolToken(args, options) {
  return new DesignTokenDefinition('bool', args, options);
}
export function textAlignmentToken(args, options) {
  return new DesignTokenDefinition('TextAlignment', args, options);
}
//# sourceMappingURL=DesignTokenDefinitions.js.map